import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateOcorrenciaColumnsDefinition
 */

type Props = {
  lockFuncionarioAprovado: boolean;
  statusInspecaoPatrimonio: number | null;
  onActionDownload: (idOcorrenciaInspecaoPatrimonio: number, nroArquivo: number) => void;
  onActionEditar: (idOcorrenciaInspecaoPatrimonio: number | null, idInspecaoPatrimonioItens: number | null, openState: boolean) => void;
  onActionDeletar: (idOcorrenciaInspecaoPatrimonio: number | null, openState: boolean) => void;
};

export const GenerateOcorrenciaColumnsDefinition = ({
  lockFuncionarioAprovado,
  statusInspecaoPatrimonio,
  onActionDownload,
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "dataCriacao",
      filterable: false,
      headerName: "Data",
      minWidth: 110,
      sortable: false,
      renderCell: ({ value }) => {
        return <div>{value ? dayjs(value).format('DD/MM/YYYY') : null}</div>
      }
    },
    {
      field: "itemInspecao",
      filterable: false,
      headerName: "Item de Inspeção",
      flex: 1,
      minWidth: 200,
      sortable: false,
    },
    {
      field: "inspecao",
      filterable: false,
      headerName: "Inspeção",
      minWidth: 110,
      width: 130,
      sortable: false,
    },
    {
      field: "existeArquivo1",
      filterable: false,
      headerName: "Arquivo 1",
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      valueGetter: (_, row) => ({
        nomeArquivo: row['nomeArquivo1'] as string,
        idOcorrencia: row['idOcorrenciaInspecaoPatrimonio'] as number,
      }),
      renderCell: ({ value }) => {
        if (!value.nomeArquivo) return <div></div>;
        return (
          <Button
            onMouseDown={() => onActionDownload(value.idOcorrencia, 1)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Arquivo 1
          </Button>
        );
      },
    },
    {
      field: "existeArquivo2",
      filterable: false,
      headerName: "Arquivo 2",
      minWidth: 100,
      maxWidth: 100,
      sortable: false,
      valueGetter: (_, row) => ({
        nomeArquivo2: row['nomeArquivo2'] as string,
        idOcorrencia: row['idOcorrenciaInspecaoPatrimonio'] as number,
      }),
      renderCell: ({ value }) => {
        if (!value.nomeArquivo2) return <div></div>;
        return (
          <Button
            onMouseDown={() => onActionDownload(value.idOcorrencia, 2)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Arquivo 2
          </Button>
        );
      },
    },
    {
      field: 'idOcorrenciaInspecaoPatrimonio',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 120,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <div className="flex items-center justify-center w-full h-full gap-2">
              <IconButton
                disabled={false}
                onClick={() => onActionEditar(params.value, null, true)}>
                <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
              </IconButton>

              <IconButton
                disabled={false}
                onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            </div>
          </div>
        );
      }
    },
  ];
}